import { Component, OnInit, ViewChild, ElementRef, EventEmitter, Output, Inject } from '@angular/core';
import { Subscription } from 'rxjs';
import {MatSidenav, MatSidenavContainer, MatBottomSheet, MatDialog} from '@angular/material';
import { MediaObserver, MediaChange } from '@angular/flex-layout';
import {ActivatedRoute, Router} from '@angular/router';
import { Location } from '@angular/common';
import { ScrollEventService } from 'src/app/common/event/scroll-event.service';
import { SideNavEventHandlerService } from 'src/app/common/event/sidenav-event-handler.service';
import { LoginService } from 'src/app/services/login.service';
import { DOCUMENT } from '@angular/common';
import { SupportComponent } from 'src/app/components/support/support.component';
import {ConfService} from '../../conf.service';
import {environment} from '../../../environments/environment';
import {LeftpanelComponent, LoaderWithProgressComponent} from '../../leftpanel/leftpanel.component';
import {JwtParserService} from '../../jwt-parser.service';

@Component({
    selector: 'app-auth-container',
    templateUrl: './auth-container.component.html',
    styleUrls: ['./auth-container.component.scss']
})
export class AuthContainerComponent implements OnInit {

    _mNavMode = "side";
    _mNavOpen = false;
    _mShowMenu = false;
    isExpanded = false;
    route: any;
    subscriptions: Subscription[] = [];
    mCurrentHeading = 1;
    _loginStatus;
    domainPartner = '';
    partnerLogo = '';
    brandImage = '';

    redirect = false;
    redirectUrl = '';
    redirectLocation = '';

    loading = true;

    _mShouldSignup = true;

    @ViewChild("fixedContent", { static: true }) public fixedContent: ElementRef;

    @ViewChild("mainDrawer", { static: true }) sidenav: MatSidenav;

    @ViewChild("sideNavContainer", { static: true })
    myScrollContainer: MatSidenavContainer;

    @ViewChild("contentScroller", { static: true }) contentScroller: ElementRef;

    @Output() public sidenavToggle = new EventEmitter();
    @Output() sidenavClose = new EventEmitter();


    constructor(
        private location: Location,
        private router: Router,
        private scrollEventService: ScrollEventService,
        private media: MediaObserver,
        private sideNavEventHandlerService: SideNavEventHandlerService,
        private _bottomSheet: MatBottomSheet,
        private loginService: LoginService,
        private confPost: ConfService,
        public dialog: MatDialog,
        private Urlroute: ActivatedRoute,
        public platform: LeftpanelComponent,
        private jwtParser: JwtParserService,
        @Inject(DOCUMENT) private document: any
    ) {
        this.media.media$.subscribe((mediaChange: MediaChange) => {
            this._mNavMode = this.getMode(mediaChange);
            this.updateSlideMode(mediaChange);
            // this.opened = this.getOpened(mediaChange);
            this.router.events.subscribe(val => {
                if (this.location.path() !== '') {
                    const routePath = this.location.path();

                    if (routePath.includes('login')) {
                        this._mShouldSignup = true;
                    } else if (routePath.includes('signup')) {
                        this._mShouldSignup = false;
                    }

                    return;
                } else {
                    this._mShouldSignup = false;
                }
            });
        });

        this.Urlroute.queryParams
            .subscribe(params => {
                const URL = window.location.href;
                if (URL.includes('localhost') || localStorage.getItem('domainPartner')) {
                    const partner = localStorage.getItem('domainPartner') ? localStorage.getItem('domainPartner') : 'dev-shanthan';
                    if (params.redirect_uri && params.redirect_uri !== '') {
                        this.redirectUrl = params.redirect_uri;
                        this.redirectLocation = params.location ? params.location : '';
                        this.redirect = true;
                    }
                }
            });
    }

    // async getLogo() {
    //     await this.confPost.getPartnerByName(localStorage.getItem('domainPartner')).toPromise().then(response => {
    //         localStorage.setItem('logo', response['logo']);
    //         localStorage.setItem('brandImage', response['brandImage']);
    //         localStorage.setItem('brandImage', response['brandImage']);
    //         this.partnerLogo = localStorage.getItem('logo');
    //         this.brandImage = localStorage.getItem('brandImage');
    //     });
    // }

    async domainCheck() {
        let partnerCheck;
        const URL = window.location.href;
        if (!URL.includes('localhost') && !URL.includes('latest.apiplatform.io')) {
            if (URL.includes('//')) {
                const temp = URL.split('//');
                partnerCheck = temp[1].split('.');
            } else {
                partnerCheck = URL.split('.');
            }
            if (partnerCheck.length > 2 && partnerCheck[0] !== 'www') {
                this.domainPartner = partnerCheck[0];
                for (const partner of environment.domainPartners) {
                    if (partner === this.domainPartner) {
                        this.domainPartner = 'services';
                        break;
                    }
                }
                await this.confPost.isValidPartner(this.domainPartner).toPromise().then(response1 => {
                    if (response1.status === 200) {
                        localStorage.setItem('domainPartner', this.domainPartner);
                        // this.getLogo();
                    }
                }, error => {});
            }
        } else {
            await this.confPost.isValidPartner(this.domainPartner).toPromise().then(response1 => {
                if (response1.status === 200) {
                    localStorage.setItem('domainPartner', this.domainPartner);
                    // this.getLogo();
                }
            }, error => {});
        }
    }

    async ngOnInit() {
        if (localStorage.getItem('Auth')) {
            if (!this.redirect) {
                this.router.navigate(['/console']);
            } else {
                const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
                    maxWidth: '95vw',
                    maxHeight: '60vh',
                });
                Promise.resolve(this.jwtParser.parseJWTToken(localStorage.getItem('JWTToken')).then(async response => {
                    const temp = response;
                    const loginPayload = {
                        emailId: temp['emailId'],
                        environment: temp['environment'],
                        password: temp['password'],
                        shash: temp['shash'],
                        ralam: temp['ralam']
                    };
                    const dt = new Date();
                    dt.setMinutes(dt.getMinutes() + 15);
                    loginPayload['expiry'] = this.platform.toTimestamp(dt) * 1000;

                    this.confPost.createJWTToken(loginPayload.environment, loginPayload.environment, localStorage.getItem('partnerKey'), {
                        claims: loginPayload,
                        consumedBy: 'apiplatform'
                    }).subscribe(response2 => {
                        if (response2 && response2['body']) {
                            loaderDialog.close();
                            window.opener.location.href = this.redirectUrl + '/authorize?token=' + response2['body'] + '&pk=' + localStorage.getItem('partnerKey') + '&location=' + this.redirectLocation;
                            window.close();
                        }
                    }, error => {
                        loaderDialog.close();
                        window.opener.location.href = this.redirectUrl + '/authorize';
                        window.close();
                    });
                }, error => {
                    loaderDialog.close();
                    window.opener.location.href = this.redirectUrl + '/authorize';
                    window.close();
                }));
            }
        }
        this.route = this.router.url;
        this.domainPartner = localStorage.getItem('domainPartner');
        this.partnerLogo = localStorage.getItem('logo');
        this.brandImage = localStorage.getItem('brandImage');
        this.loading = false;
        // await this.domainCheck();
        this.subscriptions[
            this.subscriptions.length
            ] = this.scrollEventService
            .getActionMainEmitter()
            .subscribe((heading: Number) => {
                this.mCurrentHeading = heading as number;
                this.scrollToHeader(heading);
            });

    }
    _toggleSideNav(sideNav) {
        // if (sideNav.opened == false) {
        this._drawerOpened = !this._drawerOpened;
        // }
    }

    _backdropToggle(type) {
        if (type == "backdrop") {
            this._drawerOpened = !this._drawerOpened;
        }
    }
    scrollToHeader(heading: Number) {
        // let headerClass: String = this.getHeaderClass(heading);
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    onActivate(e, outlet) {
        // this.contentScroller.nativeElement.scrollTop = 0;
        // this.myScrollContainer.scrollable.getElementRef().nativeElement.scrollTop = 0;
    }
    getMode(mediaChange: MediaChange): string {
        if (this.media.isActive("lt-md")) {
            //this._mNavOpen = false;
            return "";
        } else {
            //this._mNavOpen = false;
            return "side";
        }
    }

    _slideMode = "over";
    _drawerOpened: boolean = false;
    private updateSlideMode(mediaChange: MediaChange) {
        if (this.media.isActive("lt-md")) {
            this._slideMode = "over";
            this._drawerOpened = false;
        } else {
            this._slideMode = "over";
            this._drawerOpened = false;
        }
    }
    onActionLaunch(event) {
        this._mNavOpen = true;
        const isOpened = this.sidenav.opened;
        this.sidenav.toggle();
        this.sideNavEventHandlerService.emitMainEvent(!isOpened);
    }

    _openSupportSheet() {
        this._bottomSheet.open(SupportComponent);
    }


}
